/*
 * Garantieverlängerung als Add-on (Markup: snippets/cb-garantie.liquid).
 * Angebot nur im Warenkorb, nicht auf der Produktseite (Henrik 22.10.2026).
 * - Warenkorb und Drawer: „Ja, verlängern“ unter einem Rad; Garantien ohne ihr Rad (Rad entfernt) werden entfernt,
 *   mehr als 1 Stück je Rad wird auf 1 gesetzt (Liquid markiert diese Zeilen).
 */
(function () {
  if (window.cbGarantie) return;
  window.cbGarantie = true;

  var routes = (window.theme && theme.routes) || {};
  var CART = routes.cart_url || '/cart';
  var ADD = (routes.cart_add_url || '/cart/add') + '.js';
  var CHANGE = (routes.cart_change_url || '/cart/change') + '.js';

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function garantieItem(el) {
    return {
      id: Number(el.dataset.garantieId),
      quantity: 1,
      properties: { 'Für Rad': el.dataset.radText, _rad: String(el.dataset.radId) }
    };
  }

  // Warenkorb: Garantie entfernen
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cb-garantie-entfernen]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    post(CHANGE, { id: btn.dataset.key, quantity: 0 })
      .then(function () { window.location.reload(); })
      .catch(function () { btn.disabled = false; });
  });

  // Warenkorb und Drawer: Garantie zu einem Rad hinzufügen (aus dem Drawer weiter zur Warenkorb-Seite)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cb-garantie-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    var imDrawer = !!btn.closest('#Cart-Drawer');
    post(ADD, { items: [garantieItem(btn)] })
      .then(function () {
        if (imDrawer) window.location.href = CART;
        else window.location.reload();
      })
      .catch(function () { btn.disabled = false; });
  });

  // Warenkorb und Drawer: verwaiste oder doppelte Garantien bereinigen
  function aufraeumen() {
    var zeilen = Array.prototype.slice.call(document.querySelectorAll('[data-cb-garantie-fix]'));
    var gesehen = {};
    zeilen = zeilen.filter(function (z) {
      if (gesehen[z.dataset.key]) return false;
      gesehen[z.dataset.key] = true;
      return true;
    });
    if (!zeilen.length) return;
    // Schutz gegen eine Neuladen-Schleife, falls der Warenkorb sich nicht ändern lässt
    try {
      var zuletzt = Number(sessionStorage.getItem('cbGarantieFix') || 0);
      if (Date.now() - zuletzt < 15000) return;
      sessionStorage.setItem('cbGarantieFix', String(Date.now()));
    } catch (err) {}
    zeilen.reduce(function (kette, z) {
      return kette.then(function () {
        return post(CHANGE, { id: z.dataset.key, quantity: Number(z.dataset.cbGarantieFix) });
      });
    }, Promise.resolve())
      .then(function () { window.location.reload(); })
      .catch(function () {});
  }
  // Drawer: Shopify zeigt zuletzt Hinzugefügtes oben → Garantie direkt unter ihr Rad stellen
  function sortieren() {
    document.querySelectorAll('[data-cb-rad]').forEach(function (g) {
      var rad = g.parentNode && g.parentNode.querySelector('[data-cb-variante="' + g.dataset.cbRad + '"]');
      if (rad && rad.nextElementSibling !== g) rad.after(g);
    });
  }

  function start() {
    sortieren();
    aufraeumen();
    // Der Drawer wird nach Änderungen neu gezeichnet → erneut prüfen
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer && window.MutationObserver) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () { sortieren(); aufraeumen(); }, 150);
      }).observe(drawer, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
